export const COLOR_DEEP_FOREST = "#122A26";
export const COLOR_DEEP_FOREST_HOVER = "#305953";
export const COLOR_MANIFEST_TEAL = "#3A9289";
export const COLOR_LIGHT_TEAL = "#DFF5F4";
export const COLOR_ERROR = "#FF541E";
export const COLOR_PINK = "#FFEDED";
export const COLOR_TEXT_GRAY = "#545454";
export const COLOR_LIGHT_GRAY = "#EDEDED";
export const COLOR_GRAY_GREEN = "#C3CAC9";
export const COLOR_GRAY_GREEN_2 = "#E3E5E4";
export const COLOR_GRAY_GREEN_3 = "#F8F8F8";
export const COLOR_WHITE = "#fff";
export const COLOR_COCO_7 = "#827D78";
export const COLOR_BLACK = "#212429";
